<template lang="html">
  <div id="neighbourhood-landing" class="contained-height">
    <router-view>

    </router-view>
    <neighbourhood-nav></neighbourhood-nav>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import NeighbourhoodNav from './NeighbourhoodNav';

export default {
  name: 'neighbourhood-landing',
  props: {
  },
  computed: {
    ...mapState({
      travelMode: state => state.neighbourhood.travelMode
    }),
    ...mapGetters({
      deviceLg: 'ui/deviceLg'
    })
  },
  methods: {
  },
  watch: {
  },
  components: {
    'neighbourhood-nav': NeighbourhoodNav
  }
};
</script>

<style lang="scss" scoped>
#neighbourhood-landing {
  padding-bottom: $action-bar-height;
  background-color: var(--background);
}
</style>



// WEBPACK FOOTER //
// src/pages/NeighbourhoodPage/NeighbourhoodLanding.vue